import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@mui/material';

export const Logo = ({ fontSize }) => (
  //   <SvgIcon fontSize={fontSize} viewBox="0 0 225.000000 225.000000">
  //     <svg
  //       version="1.0"
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="300.000000pt"
  //       height="207.000000pt"
  //       viewBox="0 0 300.000000 207.000000"
  //       preserveAspectRatio="xMidYMid meet"
  //     >
  //       <g
  //         transform="translate(0.000000,207.000000) scale(0.100000,-0.100000)"
  //         fill="#000000"
  //         stroke="none"
  //       >
  //         <path
  //           d="M2949 2023 c-114 -168 -274 -356 -440 -518 -162 -158 -254 -233 -521
  // -428 -46 -34 -51 -48 -5 -16 177 124 480 374 588 486 117 121 322 371 379 462
  // 28 45 35 51 41 35 7 -17 8 -17 8 4 1 34 -15 26 -50 -25z"
  //         />
  //         <path
  //           d="M2991 1990 c-5 -123 -116 -344 -271 -540 -56 -72 -245 -262 -360
  // -363 -84 -74 -283 -217 -404 -292 -121 -74 -372 -201 -513 -260 -51 -22 -91
  // -41 -89 -43 15 -15 489 219 646 318 190 120 468 346 604 491 228 242 413 568
  // 393 696 -3 25 -4 24 -6 -7z"
  //         />
  //         <path
  //           d="M2225 1174 c-10 -8 -33 -26 -50 -39 -93 -78 -143 -115 -154 -115 -6
  // 0 -11 -4 -11 -8 0 -8 -172 -124 -187 -126 -4 0 -15 -6 -23 -13 -8 -7 -24 -20
  // -35 -28 -19 -15 -19 -16 5 -4 52 24 308 200 377 258 40 34 76 61 80 61 4 0
  // -17 -25 -47 -57 -35 -35 -44 -48 -25 -36 38 27 73 64 77 83 2 8 7 18 13 22 5
  // 4 7 9 5 12 -3 2 -14 -2 -25 -10z"
  //         />
  //         <path
  //           d="M2065 1009 c-27 -21 -98 -69 -157 -106 -60 -36 -108 -68 -108 -70 0
  // -10 175 98 256 158 32 24 63 43 67 41 5 -1 6 2 2 8 -8 12 -1 16 -60 -31z"
  //         />
  //         <path
  //           d="M1915 1031 c-17 -16 -406 -208 -520 -256 -60 -26 -127 -54 -147 -63
  // -21 -9 -36 -17 -34 -19 8 -8 311 126 505 224 150 76 207 100 212 91 5 -8 7 -5
  // 6 10 -1 24 -7 27 -22 13z"
  //         />
  //         <path
  //           d="M1590 753 c-80 -41 -134 -71 -120 -68 47 13 298 147 270 144 -3 0
  // -70 -34 -150 -76z"
  //         />
  //         <path
  //           d="M1605 736 c-155 -79 -234 -115 -378 -168 -15 -6 -26 -13 -23 -15 14
  // -14 504 210 572 262 32 24 16 17 -171 -79z"
  //         />
  //         <path
  //           d="M415 723 c-29 -7 -56 -33 -71 -70 -36 -84 52 -184 121 -139 14 9 25
  // 21 25 26 0 6 -9 1 -20 -10 -48 -48 -124 3 -124 84 0 78 74 122 158 94 25 -8
  // 43 -11 40 -7 -12 19 -87 32 -129 22z"
  //         />
  //         <path
  //           d="M596 650 c23 -25 56 -71 74 -104 22 -39 47 -67 75 -85 40 -25 42 -29
  // 30 -52 -20 -40 -26 -77 -13 -85 6 -4 8 -3 4 4 -5 9 5 50 28 103 5 12 -1 19
  // -22 28 -36 15 -70 51 -105 111 -14 25 -45 63 -69 85 l-43 40 41 -45z"
  //         />
  //         <path
  //           d="M1117 662 c-37 -13 -66 -26 -64 -28 5 -5 110 31 134 45 29 17 3 11
  // -70 -17z"
  //         />
  //         <path
  //           d="M1383 661 c-50 -20 -67 -34 -27 -22 46 14 84 30 84 36 0 7 -10 5 -57
  // -14z"
  //         />
  //         <path
  //           d="M916 594 c-43 -14 -76 -27 -73 -30 5 -5 167 44 167 51 0 7 -9 5 -94
  // -21z"
  //         />
  //         <path
  //           d="M1207 595 c-38 -13 -72 -27 -75 -31 -4 -4 0 -5 8 -2 8 3 45 15 83 27
  // 37 13 67 25 67 27 0 7 -12 4 -83 -21z"
  //         />
  //         <path
  //           d="M505 559 c26 -12 68 -79 100 -155 13 -33 24 -53 25 -45 0 19 -64 150
  // -90 184 -12 15 -29 27 -38 26 -14 0 -13 -2 3 -10z"
  //         />
  //         <path d="M808 553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
  //         <path
  //           d="M748 543 c-25 -4 -27 -7 -17 -25 13 -25 68 -48 111 -47 28 1 26 3
  // -13 9 -49 8 -89 26 -89 38 0 5 12 13 28 19 28 11 24 13 -20 6z"
  //         />
  //         <path
  //           d="M992 523 c-40 -14 -72 -27 -69 -29 2 -2 41 9 88 25 46 16 77 29 69
  // 29 -8 0 -48 -11 -88 -25z"
  //         />
  //         <path
  //           d="M1097 524 c-44 -14 -77 -27 -75 -29 5 -5 168 44 168 50 0 8 -11 5
  // -93 -21z"
  //         />
  //         <path d="M888 483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
  //         <path
  //           d="M910 459 c-77 -27 -110 -62 -110 -116 0 -24 1 -43 3 -43 14 0 108 32
  // 105 36 -3 2 -26 -2 -51 -10 l-47 -14 0 37 c0 48 24 70 108 101 34 12 62 24 62
  // 26 0 6 -12 3 -70 -17z"
  //         />
  //         <path
  //           d="M1237 453 c-37 -14 -66 -27 -64 -29 5 -5 109 31 134 45 31 18 1 11
  // -70 -16z"
  //         />
  //         <path
  //           d="M85 453 c-27 -7 -75 -53 -75 -72 0 -9 9 -2 19 15 35 58 128 67 167
  // 17 13 -17 14 -17 8 0 -12 34 -67 52 -119 40z"
  //         />
  //         <path
  //           d="M239 444 c-16 -20 2 -120 27 -144 14 -13 14 -11 -1 19 -9 19 -18 55
  // -19 80 -1 45 0 46 31 49 23 2 35 -3 47 -20 9 -12 16 -18 16 -12 0 37 -76 58
  // -101 28z"
  //         />
  //         <path
  //           d="M356 445 c-3 -8 -1 -27 4 -41 14 -35 12 -42 -5 -20 -8 11 -15 15 -15
  // 10 0 -17 29 -51 47 -56 17 -4 16 0 -5 43 -13 26 -21 53 -17 58 3 6 23 11 45
  // 11 33 0 39 -4 48 -27 11 -31 60 -88 68 -80 9 9 -16 48 -26 42 -5 -3 -18 12
  // -30 35 -19 37 -23 40 -64 40 -30 0 -46 -5 -50 -15z"
  //         />
  //         <path
  //           d="M490 451 c0 -4 11 -6 25 -4 20 4 29 -3 53 -41 35 -54 51 -134 30
  // -147 -19 -12 -255 -11 -281 2 -21 10 -21 10 -3 -5 27 -21 262 -23 291 -3 25
  // 19 14 84 -26 154 -26 45 -35 53 -60 53 -16 0 -29 -4 -29 -9z"
  //         />
  //         <path
  //           d="M1025 380 c-60 -21 -105 -39 -98 -39 13 -1 224 67 232 74 11 11 -31
  // 0 -134 -35z"
  //         />
  //         <path
  //           d="M212 359 c0 -48 -15 -74 -52 -91 -18 -7 -29 -19 -28 -28 4 -22 74
  // -25 104 -5 30 19 31 7 3 -24 -42 -45 -113 -54 -166 -21 -40 24 -54 51 -63 120
  // -7 53 -7 54 -9 12 -3 -92 56 -162 137 -162 55 0 107 28 124 65 15 33 5 41 -24
  // 21 -24 -17 -83 -22 -93 -7 -3 5 3 12 14 16 41 13 75 80 61 120 -6 15 -8 11 -8
  // -16z"
  //         />
  //         <path
  //           d="M634 325 c36 -143 56 -207 56 -181 0 18 -43 172 -51 186 -8 12 -9 11
  // -5 -5z"
  //         />
  //         <path d="M762 280 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
  //         <path
  //           d="M776 215 c3 -16 17 -43 32 -58 l27 -28 18 26 c33 45 95 24 99 -33 3
  // -53 -3 -77 -24 -95 -11 -9 -16 -17 -11 -17 6 0 18 9 28 20 21 23 24 95 6 129
  // -22 40 -94 39 -107 -1 l-6 -20 -22 21 c-11 12 -27 36 -34 54 l-12 32 6 -30z"
  //         />
  //         <path
  //           d="M690 122 c0 -22 28 -69 56 -91 42 -33 48 -24 8 11 -20 18 -43 46 -50
  // 63 -7 16 -13 24 -14 17z"
  //         />
  //         <path d="M823 3 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z" />
  //       </g>
  //     </svg>
  //   </SvgIcon>
  <img
    src="http://swordlegame.co.uk/Swordle3.png"
    style={{ maxHeight: '50px' }}
  />
);

Logo.propTypes = { fontSize: PropTypes.string };

Logo.defaultProps = {
  fontSize: 'medium',
};

export default { Logo };
